import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100 mb-8" }
const _hoisted_2 = { class: "d-flex flex-wrap justify-space-around" }
const _hoisted_3 = {
  class: "mb-5 mt-sm-0 d-flex flex-column align-center",
  justify: "center"
}
const _hoisted_4 = { class: "f-18 sz-primary-grey--text font-weight-medium my-2" }
const _hoisted_5 = { class: "d-flex justify-center font-weight-medium" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

import BaseButton from '@/components/widgets/BaseButton.vue';
import { LINKS } from '@/constants/externalLinks';
import type { Step } from '@/types';
import useEditionStageStore from '@/stores/EditionStage';
import { storeToRefs } from 'pinia';

type Props = {
  title?: string;
  steps?: Step[];
  guideButtonText?: string;
  centerStepsText?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'DonorSteps',
  props: {
    title: { default: '' },
    steps: { default: () => [] },
    guideButtonText: { default: '' },
    centerStepsText: { type: Boolean, default: true }
  },
  setup(__props: any) {

const editionStageStore = useEditionStageStore();

const {
    isCampaignUnderway
} = storeToRefs(editionStageStore);



const basePath = process.env.VUE_APP_PUBLIC_PATH ?? '/';

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_row = _resolveComponent("v-row")!
  const _directive_orphans = _resolveDirective("orphans")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", {
      class: _normalizeClass(["f-24 sz-red--text font-weight-medium mb-5 text-center", { 'font-weight-bold': _ctx.$vuetify.display.xs }])
    }, _toDisplayString(_ctx.title), 3),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "step"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_img, {
              class: "col col-12",
              position: "center",
              src: `${_unref(basePath)}${item.imagePath}`,
              cover: "",
              height: "134",
              width: "152"
            }, null, 8, ["src"]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('label.step')) + " " + _toDisplayString(index + 1) + ". ", 1),
              _createElementVNode("div", {
                class: _normalizeClass({'text-center': _ctx.centerStepsText}),
                innerHTML: item?.text
              }, null, 10, _hoisted_6),
              (item?.additionalInfo && _unref(isCampaignUnderway))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({'text-center': _ctx.centerStepsText}),
                    innerHTML: item.additionalInfo
                  }, null, 10, _hoisted_7))
                : _createCommentVNode("", true)
            ])), [
              [_directive_orphans]
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      justify: "space-around",
      class: "mt-5"
    }, {
      default: _withCtx(() => [
        _createVNode(BaseButton, {
          href: _unref(LINKS).guide,
          class: "mb-4",
          variant: "secondary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.guideButtonText), 1)
          ]),
          _: 1
        }, 8, ["href"]),
        (!_unref(isCampaignUnderway))
          ? _withDirectives((_openBlock(), _createBlock(BaseButton, {
              key: 0,
              href: _unref(LINKS).aboutSzp
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('label.readMoreSzp')), 1)
              ]),
              _: 1
            }, 8, ["href"])), [
              [_directive_orphans]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})